import SortingDropdown from './SortingDropdown';
import { connect } from 'react-redux';
import { getSearchParameters } from '../../../../state';
import {
    trackFilterClickSortMatches,
    trackSortingDropdownClick,
} from '../../../../actions';

const mapStateToProps = state => {
    const { sortType } = getSearchParameters(state);
    let sortTypeText;
    if (sortType === 'Default') {
        sortTypeText = 'default order';
    } else if (sortType === 'Distance') {
        sortTypeText = 'distance';
    } else if (sortType === 'WaitTimeRating') {
        sortTypeText = 'wait time rating';
    }

    return {
        sortTypeSelected: sortTypeText,
    };
};

const mapDispatchToProps = {
    onClickDropdown: trackSortingDropdownClick,
    onApplySort: trackFilterClickSortMatches,
};

export default connect(mapStateToProps, mapDispatchToProps)(SortingDropdown);
